import { QuantifyBarChart } from '@modules/quantify/components/QuantifyChart/QuantifyBarChart';
import { QuantifyChartProps } from '@modules/quantify/components/QuantifyChart/QuantifyChart';
import { useGetQuantifyFormulaDisplayName } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Box } from '@mui/material';

export function QuantifyAggregateFormulaValueBarChart({
  component = { barChart: {} },
}: QuantifyChartProps) {
  const { formulaDisplayName } = useGetQuantifyFormulaDisplayName({
    shouldIncludeGroupByName: true,
  });
  const valueRange = useQuantifyStore(
    ({ reportData }) => reportData.quantify.valueRange,
  );

  return (
    <Box sx={{ height: '100%', ...component.barChart?.containerSxProps }}>
      <QuantifyBarChart
        shouldShowToggleGroup={false}
        shouldShowAddToFilter={false}
        shouldShowTitle={false}
        yAxisCharLength={component.barChart?.yAxisCharLength}
        xAxis={{
          label: formulaDisplayName,
          domain: valueRange ? [valueRange.start, valueRange.end] : undefined,
        }}
        yAxis={{ label: '', tick: false }}
        shouldTakeFullHeight={component.barChart?.shouldTakeFullHeight}
      />
    </Box>
  );
}
